const ForeignLaborQuery = (id) => {
  return `
    query {
        getRecruiterById(id: "${id}") {
          id
          group_id,
          user_id,
          RecruiterFormData {
            new_profile_fl_recr_last_name
            new_profile_fl_recr_first_name
            new_profile_fl_recr_middle_name
            new_profile_fl_recr_employer_name
            new_profile_fl_recr_city
            new_profile_fl_recr_state_id
            new_profile_fl_recr_zip
            new_profile_fl_recr_country_id
            new_profile_fl_recr_province
            new_profile_fl_recr_profile_name
            new_profile_fl_recr_reg_num_1
            new_profile_fl_recr_reg_num_country_1
            new_profile_fl_recr_reg_num_2
            new_profile_fl_recr_reg_num_country_2
            new_profile_fl_recr_reg_num_3
            new_profile_fl_recr_reg_num_country_3
          }
        }
      }
      `;
};
export const ForeignLaborsQuery = (id) => {
  return `
  query {
    getRecruiterByIds(ids: ${id}) {
        id
        group_id,
        form_id,
        RecruiterFormData {
          new_profile_fl_recr_last_name
          new_profile_fl_recr_first_name
          new_profile_fl_recr_middle_name
          new_profile_fl_recr_employer_name
          new_profile_fl_recr_city
          new_profile_fl_recr_state_id
          new_profile_fl_recr_zip
          new_profile_fl_recr_country_id
          new_profile_fl_recr_province
          new_profile_fl_recr_profile_name
          new_profile_fl_recr_reg_num_1
          new_profile_fl_recr_reg_num_country_1
          new_profile_fl_recr_reg_num_2
          new_profile_fl_recr_reg_num_country_2
          new_profile_fl_recr_reg_num_3
          new_profile_fl_recr_reg_num_country_3
      }
      }
    }
    `;
};

export default ForeignLaborQuery;
